import { useState } from "react";
import { Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import ParentForm from "./parent-form";
import { swalSuccess, swalConfirm } from "src/utils/swalHelpers";
import { useParentsQuery } from "../../services/react-query-apis/get-parents";
import { useDeleteParentMutation } from "../../services/react-query-apis/delete-parent";
import BasicModal from "src/features/student-attendance/components/modal";
import ParentTaskBar from "./parent-task-bar";

const Parent = () => {
  const [modalInfo, setModalInfo] = useState({
    openModal: null,
    parent: null,
  });

  const [queryParams, setQueryParams] = useState({
    paginate: 15,
    page: 1,
    search: "",
    orderBy: "id",
    orderDirection: "desc",
  });

  const parentsQuery = useParentsQuery({
    ...queryParams,
  });

  const deleteParentMutation = useDeleteParentMutation({
    mutationConfig: {
      onSuccess: data => {
        swalSuccess(data?.message);
      },
    },
  });

  const columns = [
    {
      title: "登録番号",
      dataIndex: "id",
      key: "id",
      align: "center",
      width: 80,
      render: (_, record) => record.id.toString().padStart(4, "0"),
    },
    {
      title: "名前",
      dataIndex: "name",
      key: "name",
      align: "center",
      width: 225,
    },
    {
      title: "電話",
      dataIndex: "phone",
      key: "phone",
      align: "center",
      width: 225,
    },
    {
      title: "メール",
      dataIndex: "email",
      key: "email",
      align: "center",
      width: 250,
    },
    {
      title: "住所",
      key: "address",
      align: "center",
      width: 250,
      render: (_, record) =>
        `${record.address1 || ""} ${record.address2 || ""}`,
    },
    {
      title: "会員",
      key: "member",
      align: "center",
      render: (_, record) => {
        return (
          <div className="d-flex gap-2 flex-wrap">
            {record.members.map(member => (
              <div key={member.id}>
                <div className="d-flex gap-2">
                  <div>{member.member_code}</div>
                  <div>{member.name}</div>
                  <div>|</div>
                </div>
              </div>
            ))}
          </div>
        );
      },
    },
    {
      title: "操作",
      key: "actions",
      align: "center",
      width: 125,
      render: (_, record) => (
        <>
          <Button
            className="btn btn-sm btn-primary mx-1"
            onClick={() =>
              setModalInfo({ openModal: "update", parent: record })
            }
          >
            <FontAwesomeIcon icon="edit" />
          </Button>
          <Button
            className="btn btn-sm btn-danger mx-1"
            onClick={async () => {
              if (await swalConfirm("削除してもよろしいですか？")) {
                deleteParentMutation.mutate(record.id);
              }
            }}
          >
            <FontAwesomeIcon icon="trash" />
          </Button>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="card px-2 py-3">
        <div className="d-flex justify-content-between align-items-center">
          <p className="headline mb-0">保護者一覧</p>
        </div>
        <ParentTaskBar
          onSearch={value => setQueryParams({ ...queryParams, search: value })}
          onNew={() => setModalInfo({ openModal: "create", parent: null })}
          isLoading={parentsQuery.isPending}
        />
        <div className="mt-3">
          <Table
            columns={columns}
            dataSource={parentsQuery?.data?.data?.data}
            loading={parentsQuery.isPending}
            pagination={{
              pageSize: queryParams.paginate,
              current: queryParams.page,
              total: parentsQuery?.data?.data?.total,
              onChange: page => {
                setQueryParams({ ...queryParams, page });
              },
              showSizeChanger: false,
            }}
            rowClassName={() => "text-center"}
            locale={{
              emptyText: parentsQuery.error
                ? "データの取得に失敗しました"
                : "データがありません",
            }}
          />
          <BasicModal
            title={
              modalInfo.openModal === "create" ? "保護者追加" : "保護者編集"
            }
            isOpen={modalInfo.openModal}
            onCancel={() => setModalInfo({ openModal: null, parent: null })}
          >
            <ParentForm
              key={modalInfo.parent?.id || 0}
              selectedParent={modalInfo.parent}
              closeModal={() => setModalInfo({ openModal: null, parent: null })}
            />
          </BasicModal>
        </div>
      </div>
    </>
  );
};

export default Parent;
